const learn = {
  header: 'Aprenda + Gane',
  modules: 'Cursos disponibles',
};

export default learn;
